import { useState } from 'react';
import tempLogo from '../../static/images/temporary_logo.png';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { emptyFilters } from '../../redux/filtersSlice';
import useWindowWidth from '../../hooks/useWindowWidth.js';
import LanguageSelector from './LanguageSelector.jsx';
import { useTranslation } from 'react-i18next';

const MobileBar = ({ isLogged, level }) => {
    const {t} = useTranslation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();
    const handleTap = (link) => {
        setIsMenuOpen(false);
        link === "/" ? window.location.href = "/" : navigate(link);
    }

    // Gestisco il click sul logo
    const dispatch = useDispatch();
    const handleLogoClick = () => {
        dispatch(emptyFilters());
        navigate("/")
    }

    // Catturo il width per eliminare il logo (inline) su mobile
    const windowWidth = useWindowWidth();

    return (
        <div className='w-full flex'>

            {/* Left */}
            <div className='flex-1 flex items-center justify-start gap-2'>
                {/* Hamburger */}
                {
                    isLogged &&
                    <div className="flex flex-col justify-center items-center py-2 px-2 gap-[6px] border-2 rounded-lg cursor-pointer"
                        onClick={() => setIsMenuOpen(true)}>
                        <div className="w-[24px] h-[2px] bg-black"></div>
                        <div className="w-[24px] h-[2px] bg-black"></div>
                        <div className="w-[24px] h-[2px] bg-black"></div>
                    </div>}

                {/* Logo */}
                <img src={tempLogo} alt="TicinoWild Logo" className={`${windowWidth > 460 ? 'w-48' : (windowWidth > 400 ? 'w-[140px]' : 'w-[114px]')}`} onClick={handleLogoClick} />
            </div>

            {/* Right */}

            {/* Accedi o registrati */}
            {
                !isLogged &&
                <div className="flex gap-2 items-center">
                    <Link to="/register-login?section=Login"><div className='bg-white py-2 px-3 rounded-xl'>{t('NavBar.signIn')}</div></Link>
                    <LanguageSelector />
                </div>
                
            }

            {/* Icona profilo */}
            {/* Add activity (admin) */}
            {
                isLogged &&
                <div className='flex gap-3'>
                    {
                        level === 2 &&
                        <div className='flex-1 flex items-center justify-end gap-3'>
                            <Link to="/handle-activities"><div className='flex gap-2 items-center border rounded-full py-2 px-2.5'>
                                <i className="fi fi-rr-list-timeline mb-[-5px]"></i>
                            </div></Link>
                            <Link to="/add-edit-activity"><div className='pt-1'><i className="fi fi-sr-square-plus text-4xl text-[#225424]"></i></div></Link>
                        </div>
                    }
                    <LanguageSelector />
                </div>
            }

            {/* Overlay */}
            {
                isMenuOpen &&
                <div className='fixed top-0 right-0 bottom-0 left-0 bg-[#f7f7f8] p-8 flex flex-col justify-center gap-4 z-30'>
                    <div className='absolute top-4 right-4 cursor-pointer' onClick={() => setIsMenuOpen(false)}><i className="fi fi-rr-circle-xmark text-[#225424] text-4xl"></i></div>
                    <div className='bg-neutral-300 h-[1px] w-full'></div>
                    <h2 className='cursor-pointer' onClick={() => handleTap('/')}>{t('NavBar.home')}</h2>
                    <div className='bg-neutral-300 h-[1px] w-full'></div>
                    <h2 className='cursor-pointer' onClick={() => handleTap('/all-activities')}>{t('NavBar.activities')}</h2>
                    <div className='bg-neutral-300 h-[1px] w-full'></div>
                    <h2 className='cursor-pointer' onClick={() => handleTap('/shop')}>{t('NavBar.shop')}</h2>
                    <div className='bg-neutral-300 h-[1px] w-full'></div>
                    <h2 className='cursor-pointer' onClick={() => handleTap('/who-we-are')}>{t('NavBar.whoWeAre')}</h2>
                    <div className='bg-neutral-300 h-[1px] w-full'></div>
                    <h2 className='cursor-pointer' onClick={() => handleTap('/partner-page')}>{t('NavBar.becomePartner')}</h2>
                    <div className='bg-neutral-300 h-[1px] w-full'></div>
                    <h2 className='cursor-pointer' onClick={() => handleTap('/contacts')}>{t('NavBar.contacts')}</h2>
                    <div className='bg-neutral-300 h-[1px] w-full'></div>
                </div>
            }

        </div>
    )
}

export default MobileBar;